module.exports = __webpack_public_path__ + "img/en-GB.b4e0664f.png";